import { AbstractFrameTrigger } from "./AbstractFrameTrigger.js";
class FrameForm extends AbstractFrameTrigger {
  /**
   * Config.
   */
  static config = {
    name: "FrameForm",
    refs: ["headers[]"]
  };
  /**
   * Form submission method.
   */
  get method() {
    return this.$el.method.toLowerCase();
  }
  /**
   * Add params to the requested URL for GET submissions.
   */
  get url() {
    const url = new URL(this.$el.action);
    if (this.method === "get") {
      url.search = new URLSearchParams(new FormData(this.$el)).toString();
    }
    return url;
  }
  /**
   * Add body to the request for POST submissions.
   */
  get requestInit() {
    const requestInit = { ...super.requestInit };
    requestInit.headers ??= {};
    if (this.$refs.headers) {
      for (const header of this.$refs.headers) {
        if (header.dataset.name && header.value) {
          requestInit.headers[header.dataset.name] = header.value;
        }
      }
    }
    if (this.method === "post") {
      requestInit.method = this.method;
      requestInit.body = new FormData(this.$el);
    }
    return requestInit;
  }
  /**
   * Prevent submit on forms.
   */
  onSubmit({ event }) {
    if (this.$el.target !== "_blank") {
      event.preventDefault();
      this.trigger();
    }
  }
}
export {
  FrameForm
};
//# sourceMappingURL=FrameForm.js.map
